// extracted by mini-css-extract-plugin
module.exports = {"tfa_confirmation_wrapper":"TfaConfirmation_tfa_confirmation_wrapper__8AHpQ"};